<template>
    <div class="section01">
		<h3>
			상수도
			<button type="button" class="button-map-view" style="cursor: pointer;"
				@click.prevent="showWaterQaMapWin(true)">지도로 보기</button>
		</h3>
		<div :class="['waterworks-state', stateClass]">
			{{ stateName }}
		</div>

		<div class="waterworks-box-wrap">
			<table class="tb-list01">
				<caption>상수도 리스트</caption>
				<colgroup>
					<col>
					<col style="width:15%">
					<col style="width:15%">
					<col style="width:25%">
					<col style="width:15%">
				</colgroup>
				<thead>
				<tr>
					<th>시설명</th>
					<th>ph</th>
					<th>탁도(NTU)</th>
					<th>잔류염소 (mg/L)</th>
					<th>수온 (℃)</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="waterQuality in waterQualityList" :key="waterQuality.facNm">
					<td class="alignL">{{ waterQuality.facNm }}</td>
					<td :style="waterQuality.phState < 0 ? 'color: #D94D4F;' : ''">{{ waterQuality.phValue }}</td>
					<td :style="waterQuality.tbState < 0 ? 'color: #D94D4F;' : ''">{{ waterQuality.tbValue }}</td>
					<td :style="waterQuality.rcState < 0 ? 'color: #D94D4F;' : ''">{{ waterQuality.rcValue }}</td>
					<td :style="waterQuality.teState < 0 ? 'color: #D94D4F;' : ''">{{ waterQuality.teValue }}</td>
				</tr>
				</tbody>
			</table>
		</div>

		<transition name="modal">
            <WaterQaMapWin v-if="isShowWaterQaMapWin" @close-water-qa-map-win="showWaterQaMapWin(false)" />
        </transition>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import WaterQaMapWin from "@/views/realtime/WaterQaMapWin.vue";
import { $WC } from "@/conf/common.const.js";

export default {
  name: 'WaterQaList',
  data() {
      return {
          isShowWaterQaMapWin: false,
      };
  },
  computed: {
      ...mapGetters({
          waterQualityMap: 'getWaterQualityMap',
      }),
      waterQualityList() {
          let waterQualityList = [];

          for(let categoryNm in this.waterQualityMap) {
              waterQualityList.push(this.waterQualityMap[categoryNm]);
          }

          return waterQualityList;
      },
      badWaterQuality() {
          for(let categoryNm in this.waterQualityMap) {
              let waterQuality = this.waterQualityMap[categoryNm];
              if(waterQuality.state != 1) {
                  return waterQuality;
              }
          }
	  },
	  stateName() {
		  if(typeof this.badWaterQuality === $WC.UNDEF) {
			  return '정상';
		  } else if(this.badWaterQuality > 0) {
			  return this.badWaterQuality.facNm + ' 수질이상';
		  } else {
			  return this.badWaterQuality.facNm + ' 점검중';
		  }
	  },
	  stateClass() {
		  if(typeof this.badWaterQuality === $WC.UNDEF) {
			  return '';
		  } else if(this.badWaterQuality > 0) {
			  return 'red';
		  } else {
			  return 'gray';
		  }
	  }
  },
  methods: {
      showWaterQaMapWin(isShow) {
          this.isShowWaterQaMapWin = isShow;
	  }
  },
  components: {
      WaterQaMapWin,
  },
}
</script>
